import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import {Box, Button, Card, CardActions, CardContent, CardMedia, Container, Grid, Link, Typography} from '@material-ui/core'
import { FaGithub, FaLinkedin } from 'react-icons/fa';

const useStyles = makeStyles(theme => ({
    socials: {
        // [theme.breakpoints.between("1280", "1400")]: {
        //     top: 200,
        // },
        // background: 'white',
        position: '-webkit-sticky',
        position: 'sticky',
        top: 20,
        width: 50,
        float: 'right',
        paddingRight: 60,
        right: 60,
        // paddingTop: 60,
        // bottom: 20, 
        paddingTop: 100,
        // paddingBottom: '40px',
        // zIndex: 5,
        // border: '1px solid red'
    },
    icon: {
        color: theme.palette.type === 'dark' ? 'white' : 'black',
        '&:hover': {
            color: theme.palette.primary.main
        }
    }
}))
const Socials = () => {

    const classes = useStyles();
    
    return (
        <Grid container direction="column" spacing={3} className={classes.socials}>
            <Grid 
                item 
                onClick={()=> window.open('https://www.linkedin.com/in/ryan-tavcar-9a642416a/', "_blank")}
                className={classes.icon}
            >
                <FaGithub size={30}/>
            </Grid>
            <Grid 
                item 
                onClick={()=> window.open('https://github.com/ryanTavcar/', "_blank")}
                className={classes.icon}
            >
                <FaLinkedin size={30}/>
            </Grid>
        </Grid>
    )
}

export default Socials
